import React from "react";
import { useSelector } from "react-redux";
import { Router, Redirect, Route, Switch } from "react-router-dom";
import EnrollSteps from "../components/enrollSteps.jsx";
import SelectPlan from "../components/SelectPlan.jsx";
import SelectSharpPlan from "../components/Sharp/PlanListing/SelectPlan.jsx";
import UserLogin from "../components/Login/Login.jsx";
import PlanSelection from "../components/PlanSelection";
import history from "../Utils/History";
import Dashboard from "../components/Dashboard";
import RedirComp from "../components/RedirComp";
import UserSignUp from "../components/UserSignUp";
import Confirmation from "../Themes/Confirmation/";
import PwdResetPage from "../components/ForgotPassword/PwdResetPage.js";
import GlobalErrorPage from "../Utils/GenericUI/GlobalErrorPage.js";
import EnrollmentForms from '../components/AllSteps';
import PlanCompareGrid from '../components/Sharp/PlanListing/PlanCompareGrid.jsx';
const WebappRouter = () => {
  const {theme} = useSelector((state)=>state.login);
  const planCom = () =>{
    if(theme){
      if(theme==="Sharp"){
        return <SelectSharpPlan/>
      }else{
        return <SelectPlan/>
      }
       }else{
        return null
       }
  } 
  const planCompGrid = () =>{
    if(theme){
      if(theme==="Sharp"){
        return <PlanCompareGrid/>
      }else{
        return <PlanSelection/>
      }
       }else{
        return null
       }
  } 
  return (
    <React.Fragment>
      <Router history={history} forceRefresh={true}>
        <Switch>
          <Route exact path="/e-Enroll/login" render={() => <UserLogin />} />
          <Route exact path="/e-Enroll/signUp" render={() => <UserSignUp />} />
          <Route
            exact
            path="/e-Enroll/select-pin"
            render={() => <EnrollSteps/>}
          />
          <Route
          path="/e-enroll/resetpassword/:email"
          render={()=><PwdResetPage/>}
          />
          <Route path="/e-Enroll/select-plan" render={() => planCom()} />
          <Route
            path="/e-Enroll/compare-plan"
            render={() => planCompGrid()}
          />
          <Route path="/e-Enroll/dashboard" render={() => <Dashboard />} />
          <Route path="/e-Enroll/userLogin" render={() => <UserLogin />} />
          <Route
            path="/e-Enroll/enrollOnline"
            render={() => <EnrollmentForms />}
          />
          <Route
            path="/e-Enroll/redirect/:planId"
            exact
            render={(props) => <RedirComp {...props} />}
          />
          <Route
            path="/e-Enroll/Confirmation"
            render={() => <Confirmation />}
            component={Confirmation}
          />
          <Route
          path="/e-Enroll/Err-Page"
          render={()=><GlobalErrorPage/>}
          />
          <Redirect from="/" to="/e-Enroll/Login" />
          <Redirect from="/login" to="/e-Enroll/Login" />
          <Redirect to="/e-Enroll/Login" />
        </Switch>
      </Router>
    </React.Fragment>
  );
};
export default WebappRouter;
